import { createApi } from "@reduxjs/toolkit/query/react";
import { baseEmpDataQuery } from "../baseQuery";

export const empDataApi = createApi({
  reducerPath: "empDataApi",
  baseQuery: baseEmpDataQuery,
  endpoints: (builder) => ({
    getEmpList: builder.query<any, void>({
      query: () => "/EmployeeDetail",
    }),
  }),
});

export const { useGetEmpListQuery } = empDataApi;
